import { AppRemoveButtonPopup, AppTable, AppEditButton, FlexBox } from 'components'
import { DateFormat, DateUtility } from 'utility/date-utility'
import React, { useMemo, useState, useEffect } from 'react'
import { useTabletAndBelowMediaQuery } from 'layout'
import { List } from 'phosphor-react'
import { Card } from 'semantic-ui-react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import {
    AutoEmailBadge,
    GroupCardMetaRow,
} from './notification-group-styles'
import { countRecipients, countTemplates } from './notification-group-utils'

const ActionBoxes = ({ onEdit, onRemove }) => (
    <>
        <AppEditButton onClick={onEdit} type="button" />
        <AppRemoveButtonPopup onConfirm={onRemove} />
    </>
)

const GroupCard = ({ item, remove, onEdit }) => {
    const autoOn = item.AutoEmail === true || item.AutoEmail === 1

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header style={{ fontWeight: 600, color: '#0f172a' }}>
                    {item.GroupName}
                </Card.Header>
                <Card.Description>
                    <GroupCardMetaRow>
                        <span className="label">Templates</span>
                        <span className="value">{countTemplates(item)}</span>
                    </GroupCardMetaRow>
                    <GroupCardMetaRow>
                        <span className="label">Recipients</span>
                        <span className="value">{countRecipients(item)}</span>
                    </GroupCardMetaRow>
                    <GroupCardMetaRow>
                        <span className="label">Auto-email</span>
                        <span className="value">
                            <AutoEmailBadge $on={autoOn}>
                                {autoOn ? 'ON' : 'OFF'}
                            </AutoEmailBadge>
                        </span>
                    </GroupCardMetaRow>
                    <FlexBox className="justify-content-end mt-2">
                        <ActionBoxes
                            onEdit={() => onEdit(item)}
                            onRemove={() => remove(item.GroupId)}
                        />
                    </FlexBox>
                </Card.Description>
            </Card.Content>
        </Card>
    )
}

export const GroupList = ({
    data,
    filter,
    pageChanged,
    totalCount,
    remove,
    onEdit,
}) => {
    const isMobile = useTabletAndBelowMediaQuery()
    const columns = useMemo(
        () => [
            {
                title: 'Group Name',
                key: 'GroupName',
            },
            {
                title: 'Templates',
                render: item => <span>{countTemplates(item)}</span>,
            },
            {
                title: 'Recipients',
                render: item => <span>{countRecipients(item)}</span>,
            },
            {
                title: 'Auto-email',
                render: item => {
                    const on =
                        item.AutoEmail === true || item.AutoEmail === 1
                    return <AutoEmailBadge $on={on}>{on ? 'ON' : 'OFF'}</AutoEmailBadge>
                },
            },
            {
                title: 'Actions',
                textAlign: 'center',
                width: isMobile ? 'auto' : 150,
                render: item => (
                    <FlexBox className="justify-content-center">
                        <ActionBoxes
                            onEdit={() => onEdit(item)}
                            onRemove={() => remove(item.GroupId)}
                        />
                    </FlexBox>
                ),
            },
        ],
        [data, totalCount, filter, isMobile, onEdit, remove],
    )

    return (
        <AppTable
            data={data}
            columns={columns}
            pageChanged={pageChanged}
            filter={filter}
            totalCount={totalCount}
            mobileCard={<GroupCard remove={remove} onEdit={onEdit} />}
        />
    )
}

const CapaGroupCard = ({ item }) => (
    <Card fluid>
        <Card.Content>
            <Card.Header>{item.GroupName}</Card.Header>
            <Card.Meta>
                Created On:{' '}
                {DateUtility.dateToLocalISO(
                    new Date(item.CreatedOn),
                    DateFormat.date,
                )}
            </Card.Meta>
        </Card.Content>
    </Card>
)

export const CapaGroupList = ({
    data,
    filter,
    pageChanged,
    totalCount,
    remove,
    onAssign,
    onRename,
}) => {
    console.log('CapaGroupList data:', data)
    if (!data || data.length === 0) {
        return <p>No CAPA groups available</p> // Handle empty data scenario
    }
    const isMobile = useTabletAndBelowMediaQuery()
    const columns = useMemo(
        () => [
            // {
            //     title: 'Mapping Id',
            //     key: 'MappingId',
            // },
            {
                title: 'Group Name',
                key: 'GroupName',
            },
            {
                title: 'Group Id',
                key: 'GroupId',
            },
            {
                title: 'Created By',
                key: 'CreatedBy',
            },
            {
                title: 'Created On',
                render: item => (
                    <span>
                        {DateUtility.dateToLocalISO(
                            new Date(item.CreatedOn),
                            DateFormat.date,
                        )}
                    </span>
                ),
            },
            // {
            //     title: 'Actions',
            //     textAlign: 'center',
            //     render: item => (
            //         <FlexRow className="justify-content-center">
            //             <ActionBoxes
            //                 onRename={() => onRename(item)}
            //                 onAssign={() => onAssign(item)}
            //                 onRemove={() => remove(item.GroupId)}
            //             />
            //         </FlexRow>
            //     ),
            // },
        ],
        [data, totalCount, filter, isMobile, onRename, onAssign, remove],
    )

    return (
        <>
            <AppTable
                data={data}
                columns={columns}
                pageChanged={pageChanged}
                filter={filter}
                totalCount={totalCount}
                mobileCard={<CapaGroupCard />}
            />
        </>
    )
}

// export const ModalCapaGroupList = ({ data }) => {
//     // State for holding the data with reordered items
//     const [reorderedData, setReorderedData] = useState(
//         data.map((item, index) => ({ ...item, OrderNumber: index + 1 })), // Add OrderNumber dynamically
//     )

//     // Handle empty data scenario
//     if (!reorderedData || reorderedData.length === 0) {
//         return <p>No CAPA groups available</p>
//     }

//     const isMobile = useTabletAndBelowMediaQuery()

//     // Function to handle drag-and-drop reordering
//     const handleDragEnd = result => {
//         const { destination, source } = result
//         if (!destination) return // If dropped outside of a droppable area

//         const updatedData = Array.from(reorderedData)
//         const [removed] = updatedData.splice(source.index, 1) // Remove item from the source index
//         updatedData.splice(destination.index, 0, removed) // Insert it at the destination index

//         // Recalculate Order Numbers
//         const reorderedWithOrderNumbers = updatedData.map((item, index) => ({
//             ...item,
//             OrderNumber: index + 1,
//         }))

//         setReorderedData(reorderedWithOrderNumbers) // Update the state with the new order
//         console.log('Reordered items:', reorderedWithOrderNumbers) // Debug log
//     }

//     return (
//         <DragDropContext onDragEnd={handleDragEnd}>
//             <Droppable droppableId="droppable" direction="vertical">
//                 {provided => (
//                     <div
//                         ref={provided.innerRef}
//                         {...provided.droppableProps}
//                         className="space-y-2 max-h-96 overflow-y-auto"
//                     >
//                         {reorderedData.map((item, index) => (
//                             <Draggable
//                                 key={item.GroupId}
//                                 draggableId={item.GroupId.toString()}
//                                 index={index}
//                             >
//                                 {(provided, snapshot) => (
//                                     <div
//                                         ref={provided.innerRef}
//                                         {...provided.draggableProps}
//                                         {...provided.dragHandleProps}
//                                         className={`p-3 border rounded shadow-sm ${
//                                             isMobile
//                                                 ? 'mobile-style'
//                                                 : 'desktop-style'
//                                         } ${
//                                             snapshot.isDragging
//                                                 ? 'bg-gray-100'
//                                                 : ''
//                                         }`}
//                                         style={{
//                                             ...provided.draggableProps.style,
//                                         }}
//                                     >
//                                         <div className="space-y-1">
//                                             <p>
//                                                 <strong>Order Number:</strong>{' '}
//                                                 {item.OrderNumber}
//                                             </p>
//                                             <p>
//                                                 <strong>Mapping Id:</strong>{' '}
//                                                 {item.MappingId}
//                                             </p>
//                                             <p>
//                                                 <strong>Group Id:</strong>{' '}
//                                                 {item.GroupId}
//                                             </p>
//                                         </div>
//                                     </div>
//                                 )}
//                             </Draggable>
//                         ))}
//                         {provided.placeholder}
//                     </div>
//                 )}
//             </Droppable>
//         </DragDropContext>
//     )
// }

export const ModalCapaGroupList = ({ data }) => {
    const isMobile = useTabletAndBelowMediaQuery()

    // Keep reordered data in sync with new data from props
    const [reorderedData, setReorderedData] = useState([])

    useEffect(() => {
        if (data && data.length > 0) {
            setReorderedData(
                data.map((item, index) => ({
                    ...item,
                    id: `item-${index + 1}`,
                    OrderNumber: index + 1,
                })),
            )
        }
    }, [data]) // Re-run when `data` updates

    const handleDragEnd = result => {
        const { destination, source } = result
        if (!destination) return // Dropped outside

        const updatedData = Array.from(reorderedData)
        const [removed] = updatedData.splice(source.index, 1)
        updatedData.splice(destination.index, 0, removed)

        // Recalculate OrderNumber
        const reorderedWithOrderNumbers = updatedData.map((item, index) => ({
            ...item,
            OrderNumber: index + 1,
        }))

        setReorderedData(reorderedWithOrderNumbers)
    }

    if (!reorderedData || reorderedData.length === 0) {
        return <p>No CAPA groups available</p>
    }

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
                {provided => (
                    <div
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                        className="space-y-2 max-h-96 overflow-y-auto"
                    >
                        {reorderedData.map((item, index) => (
                            <Draggable
                                key={item.id}
                                draggableId={item.id}
                                index={index}
                            >
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        className={`p-3 border rounded shadow-sm ${
                                            isMobile
                                                ? 'mobile-style'
                                                : 'desktop-style'
                                        } ${
                                            snapshot.isDragging
                                                ? 'bg-gray-100'
                                                : ''
                                        }`}
                                        style={{
                                            ...provided.draggableProps.style,
                                        }}
                                    >
                                        <div className="flex items-center space-x-10">
                                            <div
                                                className="cursor-pointer"
                                                {...provided.dragHandleProps}
                                            >
                                                <List />
                                            </div>
                                            <div className="space-y-1">
                                                <p>
                                                    <strong>
                                                        Order Number:
                                                    </strong>{' '}
                                                    {item.OrderNumber}
                                                </p>
                                                <p>
                                                    <strong>Mapping Id:</strong>{' '}
                                                    {item.MappingId}
                                                </p>
                                                <p>
                                                    <strong>Group Id:</strong>{' '}
                                                    {item.GroupId}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    )
}
